/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIProductionOrderStatusEnum } from './APIProductionOrderStatusEnum';
import {
    APIProductionOrderStatusEnumFromJSON,
    APIProductionOrderStatusEnumFromJSONTyped,
    APIProductionOrderStatusEnumToJSON,
} from './APIProductionOrderStatusEnum';
import type { APIPlanningEnum } from './APIPlanningEnum';
import {
    APIPlanningEnumFromJSON,
    APIPlanningEnumFromJSONTyped,
    APIPlanningEnumToJSON,
} from './APIPlanningEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedProductionOrderRequest
 */
export interface APIPatchedProductionOrderRequest {
    /**
     * 
     * @type {Date}
     * @memberof APIPatchedProductionOrderRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIPatchedProductionOrderRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedProductionOrderRequest
     */
    customerOrder?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedProductionOrderRequest
     */
    article?: string;
    /**
     * 
     * @type {APIProductionOrderStatusEnum}
     * @memberof APIPatchedProductionOrderRequest
     */
    status?: APIProductionOrderStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof APIPatchedProductionOrderRequest
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedProductionOrderRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedProductionOrderRequest
     */
    comment?: string;
    /**
     * 
     * @type {APIPlanningEnum}
     * @memberof APIPatchedProductionOrderRequest
     */
    planning?: APIPlanningEnum | null;
    /**
     * 
     * @type {number}
     * @memberof APIPatchedProductionOrderRequest
     */
    priority?: number | null;
}



/**
 * Check if a given object implements the APIPatchedProductionOrderRequest interface.
 */
export function instanceOfAPIPatchedProductionOrderRequest(value: object): value is APIPatchedProductionOrderRequest {
    return true;
}

export function APIPatchedProductionOrderRequestFromJSON(json: any): APIPatchedProductionOrderRequest {
    return APIPatchedProductionOrderRequestFromJSONTyped(json, false);
}

export function APIPatchedProductionOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedProductionOrderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'dueDate': json['due_date'] == null ? undefined : (new Date(json['due_date'])),
        'customerOrder': json['customer_order'] == null ? undefined : json['customer_order'],
        'article': json['article'] == null ? undefined : json['article'],
        'status': json['status'] == null ? undefined : APIProductionOrderStatusEnumFromJSON(json['status']),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'description': json['description'] == null ? undefined : json['description'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'planning': json['planning'] == null ? undefined : APIPlanningEnumFromJSON(json['planning']),
        'priority': json['priority'] == null ? undefined : json['priority'],
    };
}

export function APIPatchedProductionOrderRequestToJSON(value?: APIPatchedProductionOrderRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'start_date': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'due_date': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'customer_order': value['customerOrder'],
        'article': value['article'],
        'status': APIProductionOrderStatusEnumToJSON(value['status']),
        'amount': value['amount'],
        'description': value['description'],
        'comment': value['comment'],
        'planning': APIPlanningEnumToJSON(value['planning']),
        'priority': value['priority'],
    };
}

